import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "g-row g-row--align_center g-row--appearance_spaced g-row--space_lg-lg g-row--space_xl-xl mo-space_mt mo-space_mt--5" }
const _hoisted_2 = { class: "global-error" }
const _hoisted_3 = { class: "global-error" }
const _hoisted_4 = { class: "global-error" }
const _hoisted_5 = { class: "global-error" }
const _hoisted_6 = { class: "g-cell g-cols g-cols--12 mo-space_mt mo-space_mt--5 mo-space_mt--8-lg" }
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = { class: "mo-button__text" }
const _hoisted_9 = { class: "g-row g-row--align_center g-row--appearance_spaced g-row--space_lg-lg g-row--space_xl-xl mo-space_mt mo-space_mt--3 mo-space_mt--5-xl" }
const _hoisted_10 = { class: "g-cell g-cols g-cols--12 g-cols--auto-xl" }
const _hoisted_11 = { class: "ds-caption ds-caption--size_sm ds-caption--size_md-xl ds-caption--color_light ds-caption--appearance_center ds-caption--appearance_medium ds-caption--appearance_start" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_vee_error = _resolveComponent("vee-error")!
  const _component_d_control_recaptcha = _resolveComponent("d-control-recaptcha")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createBlock(_component_VeeForm, {
    onSubmit: $setup.request,
    ref: "formRef"
  }, {
    default: _withCtx(({ errors, validate, values, setErrors, setFieldError, isSubmitting }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.FIELDS, ({ name, label, mask, size, ...rest }) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["g-cell g-cols g-cols--12", `g-cols--${size || 12}-lg`])
            }, [
              _createVNode(_component_d_control_input, _mergeProps({
                class: "is-public",
                name: name,
                errors: errors,
                "input-label": label,
                "static-label": label,
                modelValue: $setup.form[name],
                "onUpdate:modelValue": ($event: any) => (($setup.form[name]) = $event),
                ref_for: true
              }, rest), null, 16, ["name", "errors", "input-label", "static-label", "modelValue", "onUpdate:modelValue"])
            ], 2))
          }), 256)),
          _createVNode(_component_vee_error, {
            class: "g-cell g-cols g-cols--12",
            name: "nonFieldErrors",
            as: "div"
          }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(message), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_vee_error, {
            class: "g-cell g-cols g-cols--12",
            name: "coordinator",
            as: "div"
          }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(message), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_vee_error, {
            class: "g-cell g-cols g-cols--12",
            name: "recaptcha",
            as: "div"
          }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(message), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_vee_error, {
            class: "g-cell g-cols g-cols--12",
            name: "token",
            as: "div"
          }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(message), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_d_control_recaptcha, {
            class: "control-descriptor--clear",
            modelValue: $setup.form.captcha,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.captcha) = $event)),
            ref: "captchaConfirmedRef",
            onVerify: ($event: any) => ($setup.saveConfirmedCaptcha($event, setFieldError))
          }, null, 8, ["modelValue", "onVerify"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode($setup["TokenConfirmationCheck"], {
              token: $setup.form.phone,
              action: $event => $setup.redirect($event, $setup.formRef)
            }, {
              default: _withCtx(({ is_confirmed, sendCode, openModal }) => [
                _createVNode(_component_d_control_recaptcha, {
                  class: "control-descriptor--clear",
                  modelValue: $setup.form.captcha,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.captcha) = $event)),
                  ref: "captchaRef",
                  onVerify: ($event: any) => ($setup.saveCaptcha($event, $setup.formRef, openModal))
                }, null, 8, ["modelValue", "onVerify"]),
                _createElementVNode("button", {
                  class: "mo-button mo-button--variant_primary mo-button--slim",
                  type: "submit",
                  disabled: isSubmitting || $setup.isLoad,
                  onClick: _withModifiers(($event: any) => ($setup.validateForm(validate, $setup.getCaptcha, $setup.formRef)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString($setup.$t('Sign up')), 1)
                ], 8, _hoisted_7)
              ]),
              _: 2
            }, 1032, ["token", "action"])
          ])
        ]),
        _renderSlot(_ctx.$slots, "text"),
        _renderSlot(_ctx.$slots, "btns"),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, [
              _createTextVNode(_toDisplayString($setup.$t('By sign up, you agree to')) + " ", 1),
              _createElementVNode("a", {
                class: "mo-link mo-link--appearance_underline mo-link--size_sm mo-link--inline",
                href: $setup.userAgreement,
                target: "_blank"
              }, _toDisplayString($setup.$t('User agreement')), 9, _hoisted_12),
              _createTextVNode(" " + _toDisplayString($setup.$t('and')) + " ", 1),
              _createElementVNode("a", {
                class: "mo-link mo-link--appearance_underline mo-link--size_sm mo-link--inline",
                href: $setup.privacyPolicy,
                target: "_blank"
              }, _toDisplayString($setup.$t('Privacy Policy')), 9, _hoisted_13)
            ])
          ])
        ])
      ])
    ]),
    _: 3
  }, 512))
}